import React, {useState} from 'react'
import DataFetcher from './DataFetcher'

import refreshIcon from "../assets/icons8-refresh-64.png"




export default function Tools({brandColor, handleChange}) {

    const [refresh, setRefresh] = useState(false)

    function handleRefresh(e) {
        e.preventDefault()
        setRefresh(!refresh)
    }
    

    return (
        <div className="tools">
            <h2>Tools</h2>
            <div className="tools--config">
                <h4>1. Select a background<span>&nbsp;<a href="#" onClick={(e) => handleRefresh(e)}><img src={refreshIcon} width={16} height={16} /></a></span></h4>
                <div className="backgrounds-wrapper">
                    <DataFetcher refresh={refresh} url={ `/api/unsplash` } >
                        {({loading, error, data}) => {
                            if (loading) return <p>Loading awesome backgrounds from Unsplash.</p>
                            if (error) return <p>Uh oh, can't load backgrounds from Unsplash API 😢 Please try again later.</p>
                            {setRefresh(false)}
                            return (
                                <div className="backgrounds">
                                    {data.map(item => (
                                        <div className="backgrounds-container" key={item.id} >
                                            <img
                                            alt={item.description}
                                            className="background-img"
                                            src={item.urls.regular}
                                            name="background"
                                            onClick={(event) => handleChange(event)}
                                            />
                                            <small>Photo by <a href={`${item.user.links.html}?utm_source=zoom-background-generator&utm_medium=referral`} target="_blank" rel="noreferrer">{item.user.name}</a> on <a href="https://unsplash.com/?utm_source=zoom-background-generator&utm_medium=referral">Unsplash</a></small> 
                                        </div>    
                                         
                                    ))}
                                </div>
                            )
                        }}  
                    </DataFetcher>
                </div>
                <h4>2. Select brand color</h4>
                <div className="brandcolor">
                    <input
                        type="color" 
                        name="brandcolor"
                        value={brandColor}
                        onChange={(event) => handleChange(event)}
                    />
                </div>
                <h4>3. Upload brand square logo </h4>
                <small>ie. 250 x 250 px</small>
                <div className="brandlogo">
                    <input 
                        id="file-upload-btn"
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                        hidden
                        onChange={(event) => handleChange(event)}
                    />
                    <label htmlFor="file-upload-btn">Choose File</label>
                </div>
            </div>
        </div>
        
        
    )
}